/**
 * SoA 类型注册器
 * 负责类型推断、TypedArray 创建和元数据管理
 */
export class SoATypeRegistry {
    /**
     * 获取 TypedArray 构造函数
     */
    static getConstructor(typeName) {
        return this.TYPE_CONSTRUCTORS[typeName] || Float32Array;
    }
    /**
     * 获取每个元素的字节数
     */
    static getBytesPerElement(typeName) {
        return this.TYPE_BYTES[typeName] || 4;
    }
    /**
     * 从 TypedArray 实例获取类型名称
     */
    static getTypeName(array) {
        if (array instanceof Float32Array)
            return 'float32';
        if (array instanceof Float64Array)
            return 'float64';
        if (array instanceof Int32Array)
            return 'int32';
        if (array instanceof Uint32Array)
            return 'uint32';
        if (array instanceof Int16Array)
            return 'int16';
        if (array instanceof Uint16Array)
            return 'uint16';
        if (array instanceof Int8Array)
            return 'int8';
        if (array instanceof Uint8Array)
            return 'uint8';
        if (array instanceof Uint8ClampedArray)
            return 'uint8clamped';
        return 'float32';
    }
    /**
     * 创建新的 TypedArray（与原数组同类型）
     */
    static createSameType(source, capacity) {
        const typeName = this.getTypeName(source);
        const Constructor = this.getConstructor(typeName);
        return new Constructor(capacity);
    }
    /**
     * 从组件类型提取字段元数据
     */
    static extractFieldMetadata(componentType) {
        const instance = new componentType();
        const metadata = new Map();
        const typeWithMeta = componentType;
        // 收集装饰器标记
        const decoratorMap = new Map();
        const addDecorators = (fields, type) => {
            if (fields) {
                for (const key of fields)
                    decoratorMap.set(key, type);
            }
        };
        addDecorators(typeWithMeta.__float64Fields, 'float64');
        addDecorators(typeWithMeta.__float32Fields, 'float32');
        addDecorators(typeWithMeta.__int32Fields, 'int32');
        addDecorators(typeWithMeta.__uint32Fields, 'uint32');
        addDecorators(typeWithMeta.__int16Fields, 'int16');
        addDecorators(typeWithMeta.__uint16Fields, 'uint16');
        addDecorators(typeWithMeta.__int8Fields, 'int8');
        addDecorators(typeWithMeta.__uint8Fields, 'uint8');
        addDecorators(typeWithMeta.__uint8ClampedFields, 'uint8clamped');
        // 遍历实例属性
        const instanceKeys = Object.keys(instance).filter((key) => key !== 'id');
        for (const key of instanceKeys) {
            const value = instance[key];
            const type = typeof value;
            if (type === 'function')
                continue;
            const fieldMeta = {
                name: key,
                type: type
            };
            const decoratorType = decoratorMap.get(key);
            if (decoratorType) {
                fieldMeta.arrayType = decoratorType;
            }
            else if (type === 'number') {
                fieldMeta.arrayType = 'float32';
            }
            else if (type === 'boolean') {
                fieldMeta.arrayType = 'uint8';
            }
            // 序列化标记
            if (typeWithMeta.__serializeMapFields?.has(key)) {
                fieldMeta.isSerializedMap = true;
            }
            if (typeWithMeta.__serializeSetFields?.has(key)) {
                fieldMeta.isSerializedSet = true;
            }
            if (typeWithMeta.__serializeArrayFields?.has(key)) {
                fieldMeta.isSerializedArray = true;
            }
            if (typeWithMeta.__deepCopyFields?.has(key)) {
                fieldMeta.isDeepCopy = true;
            }
            metadata.set(key, fieldMeta);
        }
        return metadata;
    }
}
SoATypeRegistry.TYPE_CONSTRUCTORS = {
    float32: Float32Array,
    float64: Float64Array,
    int32: Int32Array,
    uint32: Uint32Array,
    int16: Int16Array,
    uint16: Uint16Array,
    int8: Int8Array,
    uint8: Uint8Array,
    uint8clamped: Uint8ClampedArray
};
SoATypeRegistry.TYPE_BYTES = {
    float32: 4,
    float64: 8,
    int32: 4,
    uint32: 4,
    int16: 2,
    uint16: 2,
    int8: 1,
    uint8: 1,
    uint8clamped: 1
};
//# sourceMappingURL=SoATypeRegistry.js.map